module.exports = __webpack_public_path__ + "img/UTCORA-5.a7eff034.jpg";